import { Button, Card } from "react-bootstrap";
import { IoMdAddCircle } from "react-icons/io";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import axios from 'axios';
import { FaEdit } from "react-icons/fa";
function ManageTask() {
  const [showForm, setShowForm] = useState(false);
  const [getService, setGetService] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [services, setServices] = useState([]);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [plans, setPlan] = useState([]);
  const [getStaff, setGetStaff] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [planOptions, setPlanOptions] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [time, setTime] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    code: '',
    sale_price: "",
    mrp: '',
    months: '',
    service_name: []
  });
  const handleInputChange = e => {
    const {
      name,
      value,
      files
    } = e.target;
    if (name === "image") {
      setFormData({
        ...formData,
        [name]: files[0]
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  const handleCancel = () => {
    setShowForm(false);
    setIsEditMode(false);
    resetForm();
  };
  const resetForm = () => {
    setFormData({
      name: "",
      code: '',
      sale_price: "",
      mrp: '',
      months: '',
      service_name: ''
    });
  };
  const handleSubmit = () => {};
  const fetchPlan = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-subscription-plan");
      setPlan(res.data);

      // ✅ map to react-select format
      const options = res.data.map(item => ({
        value: item.id,
        label: item.name
      }));
      setPlanOptions(options);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchSetaff = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-staff");
      const sortedData = res.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setGetStaff(sortedData);

      // ✅ convert to react-select format
      const options = sortedData.map(item => ({
        value: item.id,
        label: item.name
      }));
      setStaffOptions(options);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchSetaff();
    fetchPlan();
  }, []);
  return <div className="container-fluid mt-1 p-4">
            <h2 className="text-center mb-4 text-white">Manage Task </h2>

            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">

                {/* Left: Search */}
                <input type="text" className="form-control" style={{
        maxWidth: "300px"
      }} placeholder="Search task..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />

                {/* <Button variant="primary" onClick={() => { setShowForm(true) }}>
                    <IoMdAddCircle /> Add
                 </Button> */}
            </div>

         

<div className="rounded-4 p-3 mt-4" style={{
      backgroundColor: "var(--black)",
      border: "1px solid #2d3748"
    }}>
  {/* Header ONLY title */}
  <div className="mb-3">
    <h5 className="text-white mb-0">Task List</h5>
  </div>

  {/* Table */}
  <div className="table-responsive">
    <table className="table align-middle text-center mb-0">

      <thead>
        <tr>
          <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>ID</th>
            <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>User Name</th>
          <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Assigned To</th>
          <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Date</th>
          <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Assigned Staff</th>
        
      
        </tr>
      </thead>

      <tbody>

        <tr style={{
              borderBottom: "1px solid #1e293b"
            }}>
          <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>1</td>
            <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>Aakash Singh</td>
          <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>Ravi Kumar</td>
          <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>2026-04-15</td>
          <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>
  <button className="btn btn-sm btn-outline-primary" onClick={() => {
                  setSelectedRow();
                  setShowModal(true);
                }}>
    Assign
  </button>
</td>
        
        
        </tr>

        <tr style={{
              borderBottom: "1px solid #1e293b"
            }}>
          <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>2</td>
              <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>Manvi</td>
          <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>Amit Sharma</td>
          <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>2026-04-15</td>
              <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>
  <button className="btn btn-sm btn-outline-primary" onClick={() => {
                  setSelectedRow();
                  setShowModal(true);
                }}>
    Assign
  </button>
</td>
      
         
        </tr>

        <tr style={{
              borderBottom: "1px solid #1e293b"
            }}>
          <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>3</td>
              <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>Liya</td>
          <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>Neha Verma</td>
          <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>2026-04-15</td>
            
                <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>
  <button className="btn btn-sm btn-outline-primary" onClick={() => {
                  setSelectedRow();
                  setShowModal(true);
                }}>
    Assign
  </button>
</td>
      
      
        </tr>

      </tbody>
    </table>
  </div>


  {showModal && <div className="modal fade show" style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.6)"
      }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content" style={{
            backgroundColor: "var(--black)",
            color: "#fff",
            border: "1px solid #2d3748"
          }}>

        {/* 🔥 HEADER */}
        <div className="modal-header border-0">
          <h5 className="modal-title">Assign Staff</h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
        </div>

        {/* 🔥 BODY */}
        <div className="modal-body">

          {/* STAFF */}
          <div className="mb-3">
            <label className="form-label">Select Staff</label>
            <select className="form-select" value={selectedStaff} onChange={e => setSelectedStaff(e.target.value)} style={{
                  backgroundColor: "var(--black2)",
                  color: "#fff",
                  border: "1px solid #444"
                }}>
              <option value="">Select</option>
              <option value="1">Ravi</option>
              <option value="2">Amit</option>
            </select>
          </div>

          {/* TIME */}
          <div className="mb-3">
            <label className="form-label">Time</label>
            <input type="time" className="form-control" value={time} onChange={e => setTime(e.target.value)} style={{
                  backgroundColor: "var(--black2)",
                  color: "#fff",
                  border: "1px solid #444"
                }} />
          </div>

        </div>

        {/* 🔥 FOOTER */}
        <div className="modal-footer border-0">
          <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
            Cancel
          </button>

          <button className="btn btn-primary" onClick={() => {
                // console.log(selectedRow, selectedStaff, time);
                setShowModal(false);
              }}>
            Save
          </button>
        </div>

      </div>
    </div>
  </div>}
</div>

        </div>;
}
export default ManageTask;
